import { useEffect } from 'react';

let activeLocks = 0;
let previousOverflow = '';
let previousPaddingRight = '';

const getScrollbarWidth = () => {
  if (typeof window === 'undefined' || !document?.documentElement) return 0;
  return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
};

const lockBodyScroll = () => {
  if (typeof document === 'undefined') return () => {};

  activeLocks += 1;

  if (activeLocks === 1) {
    const { body } = document;
    const scrollbarWidth = getScrollbarWidth();

    previousOverflow = body.style.overflow;
    previousPaddingRight = body.style.paddingRight;

    body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
      body.style.paddingRight = `${scrollbarWidth}px`;
    }
  }

  return () => {
    activeLocks = Math.max(0, activeLocks - 1);

    if (activeLocks === 0 && typeof document !== 'undefined') {
      document.body.style.overflow = previousOverflow;
      document.body.style.paddingRight = previousPaddingRight;
    }
  };
};

const useBodyScrollLock = (locked) => {
  useEffect(() => {
    if (!locked) return undefined;
    return lockBodyScroll();
  }, [locked]);
};

export default useBodyScrollLock;
